import {createStrokeSVG} from './TEMPLATE'

// tabler: circle-x
export const CircleX_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: ['M3 12a9 9 0 1 0 18 0a9 9 0 1 0 -18 0', 'M10 10l4 4m0 -4l-4 4'],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
